module.exports = __webpack_public_path__ + "public/media/step_2_guess_volcano.low.597be678.mp4";